import differenceInDays from 'date-fns/differenceInDays';

class TimeGuard {
  constructor(private storageKey) {}

  static create(storageKey) {
    return new TimeGuard(storageKey);
  }

  check(countFirstRun = true) {
    let lastRequest = undefined;
    try {
      lastRequest = window.localStorage.getItem(this.storageKey);
    } catch (e) {}
    if (lastRequest) {
      const data = JSON.parse(lastRequest);
      return differenceInDays(new Date(), data.date) >= data.timeoutInDays;
    }
    if (!countFirstRun) {
      this.setTimeoutForDays(1);
      return false;
    }
    return true;
  }

  setTimeoutForDays(timeoutInDays) {
    const data = { timeoutInDays, date: new Date().toISOString() };
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(data));
    } catch (e) {}
  }
}

export default TimeGuard;
